import { analyticsInit } from '@logic/analytics';
import { UserApi } from 'shared/types';

import { atom, onSet } from 'nanostores';

export const $currentUser = atom<UserApi>();
onSet($currentUser, ({ newValue: user }) => analyticsInit(user.id));
